import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: "https://propertysearch.ai/", 
});

axiosInstance.interceptors.response.use(
  (response) => response, 
  (error) => {
    if (error.response && error.response.status === 403) {
    console.log("Token is expired. Redirecting to login...");
      setTimeout(() => {
        sessionStorage.clear(); 
        window.location.href = "/login"; 
      }, 1000);
    }
    return Promise.reject(error); 
  }
);

export default axiosInstance;
